import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 07CA9ED6-5D94-4145-AB3E-EA9FD7283E0A
 * name star-box
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-box.svg
 * tags
 */
export const StarBoxIcon = createSvgIcon(<><path d="M19,3A2,2 0 0,1 21,5V19C21,20.11 20.1,21 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M15.58,17L14.63,12.92L17.79,10.19L13.62,9.83L12,6L10.38,9.84L6.21,10.2L9.37,12.93L8.42,17L12,14.84L15.58,17Z" /></>, 'StarBoxIcon');
export default StarBoxIcon